export default {
    components: {
        mainMenu: {
            show: true,
        },
        moduleMenu: {
            show: true,
        },
        block: {
            open: true,
            animated: true,
            refreshButton: true,
            unmountClose: false,
        },
        blockTable: {
            historyOpen: false,
            animated: true,
        },
        dialog: {
            contentsPath: 'components/Dialog/components/',
            contents: {
                about: {
                    component: 'About',
                },
                confirm: {
                    component: 'Confirm',
                },
                infoPaidData: {
                    component: 'InfoPaidData',
                },
                userProfile: {
                    component: 'UserProfile',
                },
                groupMembersImport: {
                    component: 'GroupMembersImport',
                },
                groupMonitoring: {
                    component: 'GroupMonitoring',
                },
                manageGroups: {
                    component: 'ManageGroups',
                },
                reportOwnershipConfirm: {
                    component: 'ReportOwnershipConfirm',
                },
            },
        },
        entityStack: {
            defaults: {
                selectedTab: 'search',
            },
            search: {
                key: 'search',
                visible: true,
                quickAutocomplete: true, // turn on/off quick autocomplete functionality
                simulatedPreloadDelay: 250, // setup delay time for "loading" on storage collection merge in miliseconds
                historySize: 20, // setup number of stored history results
                searchLimit: 100, // search request limit
                invalidationTime: 48, // time for force collection load without storage data in hours
            },
            favourites: {
                key: 'favourites',
                visible: true,
            },
            groups: {
                key: 'groups',
                visible: true,
            },
            history: {
                key: 'history',
                visible: true,
                limit: 200,
            },
            exports: {
                key: 'exports',
                visible: true,
            },
            collapse: {
                key: 'collapse',
                visible: true,
            },
            filter: {
                key: 'filter',
                visible: false,
            },
        },
        minireport: {
            enable: true,
        },
    },
}
